export default {
  utility_search_subtitle_all:
    'all members with notifications enabled for mentions',
  utility_search_subtitle_online:
    'members seen within the last {minute} min and have notifications enabled for mentions',
};
